import { commonAxios } from '@/plugins/axios'

export const toBeFriend = async (params) =>
  commonAxios.get(`/v1/common/social/line`, {
    params,
  })
